import ModalRoutes from '@medical/components/ModalRoutes'
import DoctorLayout from '@medical/layout/DoctorLayout/DoctorLayout'
import StaffLayout from '@medical/layout/StaffLayout/StaffLayout'
import middleware from '@medical/middleware'
import React from 'react'
import { Redirect, Route, useLocation } from 'react-router-dom'
import Permission from './Permission'
import Router from './router'

const useQuery = () => {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}

const ProtectedRoute = ({
  component: Component,
  redirect,
  permissionId,
  modals = [],
  ...rest
}) => {
  let query = useQuery();
  let redirectUrl = ''
  const dateRage = query.get('dateRange');
  const clinics = query.get('clinics')
  const departments = query.get('departments')
  const startTime = query.get('startTime')
  if (dateRage && clinics && departments && startTime) {
    redirectUrl = '?redirect=/doctor/Search_Result?' + encodeURIComponent(`dateRange=${dateRage}&clinics=${clinics}&departments=${departments}&startTime=${startTime}&utm_source=weekly_recommended_shifts&utm_medium=email`)
  }
  const utm_source = query.get('utm_source');
  if (utm_source === 'newsletter') {
    redirectUrl = '?redirect=/doctor/news/?utm_source=newsletter&utm_medium=email';
  }
  if (utm_source === 'waiting_recruitment_shifts') {
    redirectUrl = `?redirect=/doctor/available_shifts/${new Date().getFullYear()}/${new Date().getMonth() + 1}/?utm_source=newsletter&utm_medium=email`;
  }
  return (
    <Route
      {...rest}
      render={routerProps => {
        const props = { ...rest, ...routerProps }
        if (middleware.isDoctor() && redirect === Router.doctorLogin) {
          return (
            <DoctorLayout {...props}>
              <Component {...props} />
              <ModalRoutes modals={modals} />
            </DoctorLayout>
          )
        }
        if (middleware.isStaff() && redirect === Router.staffLogin) {
          return (
            <StaffLayout {...props}>
              <Permission permissionId={permissionId}>
                <Component {...props} />
                <ModalRoutes modals={modals} />
              </Permission>
            </StaffLayout>
          )
        }
        return <Redirect to={redirect + redirectUrl} />
      }}
    />
  )
}

export default ProtectedRoute
